import { FormikErrors } from 'formik'

import { FormValues } from './types'

const VALID_REGEX = /^[\d\sA-Za-z]+$/

const validator = (values: FormValues) => {
  const errors: {
    keywords?: FormikErrors<FormValues['keywords'][0]>[]
  } = {}

  values.keywords.forEach((keyword, index) => {
    if (keyword && !VALID_REGEX.test(keyword)) {
      errors.keywords = errors.keywords ?? []
      errors.keywords[index] = 'Please enter a valid keyword'
    }
  })

  return errors
}

export const getErrorMsgs = (errors: string | string[]): string[] => {
  if (Array.isArray(errors) && errors.every(err => typeof err === 'string')) {
    return [...new Set(errors.filter(err => err !== ''))]
  }

  return []
}

export default validator
